// 按下空格的down 开启麦克风
// 按下空格的up 关闭麦克风

import { useCallback, useEffect, useRef, useState } from 'react'
import { useAudioRecording } from './use-audio-recording'
import { getASRSync } from '@/services/volcanoSpeechService'
import { useStore } from '@/store'
import { DigitalHumanMode } from '@/store/types'
import { sendRequest } from '@/services/api'
import { useMutationGetAgentData } from '@/services/hooks'
import useControl from '@/store/useControl'
import { message } from 'antd'
import { getDigitalStore, useDigitalStore } from '@/store/digital'
import { someBusinessCaseToChat } from '@/pages/DigitalHuman/util/util'

export function useButton({
  handleChat,
  handleStop
}: {
  handleChat: (text: string) => void
  handleStop: () => void
}) {
  const { toggleDigitalHumanMode } = useStore()
  const { update } = useDigitalStore()
  const [text, setText] = useState('')
  const [isAgentProcessing, setIsAgentProcessing] = useState(false)
  const { mutateAsync: getAgentData } = useMutationGetAgentData()
  const { set: setAgentData } = useControl()


  const {
    isListening,
    isRecording,
    isTranscribing,
    startListening,
    stopRecording
  } = useAudioRecording({
    transcribeAudio: async (blob) => {
      try {
        handleStop();
        const t = new Date().getTime()
        getDigitalStore().update((state) => {
          state.agentLastFetchDate = t
        })
        const id = `xihu-city-walk-${new Date().getTime()}`
        const res = await sendRequest.uploadBlob(blob, `${id}.wav`);
        const data = await getASRSync({
          sessionId: id,
          id,
          address: res.url,
        })
        const text = data?.data?.data?.text || data?.data?.data?.originalText
        console.info("【agent】asr识别:", text, new Date().getTime() - t + 'ms')
        if (!text) {
          message.warning({
            content: "没识别到你说话，再说一次吧~",
            icon: <></>
          });
          throw new Error('语音识别失败')
        }
        setText(text)
        setIsAgentProcessing(true)
        const t2 = new Date().getTime()
        const agentRes = await getAgentData(text)
        console.info("【agent】agent处理:", agentRes, new Date().getTime() - t2 + 'ms')
        const agentData = agentRes?.data?.outputs
        if (getDigitalStore().agentLastFetchDate !== t) {
          console.log('检测到新的问答，停止此次问答', text)
          return;
        }
        if (!agentData?.mode || (agentData?.mode === '无') || someBusinessCaseToChat(agentData)) {
          handleChat(text)
        } else {
          toggleDigitalHumanMode(DigitalHumanMode.CORNER)
          setAgentData(agentData as any);
        }
        console.info("【agent】agent outputs:", agentData)
        setIsAgentProcessing(false)
        return text
      } catch (error) {
        console.error('【agent】语音识别失败', error)
      }
    },
    onTranscriptionComplete: (text) => {
      console.log('语音识别结果:', text)
    }
  })

  const handleKeyDown = useCallback((event: KeyboardEvent) => {
    if (event.code === 'Space') {
      event.preventDefault()
      if (getDigitalStore().isSpacePressed) {
        return
      }
      console.log('检测按下空格键')
      update(state => {
        state.isSpacePressed = true
      })
      startListening()
      toggleDigitalHumanMode(DigitalHumanMode.FULLSCREEN)
      handleStop()
      console.log('麦克风已开启')
    }
  }, [handleStop, startListening, toggleDigitalHumanMode, update])

  const handleKeyUp = useCallback((event: KeyboardEvent) => {
    if (event.code === 'Space') {
      event.preventDefault()
      update(state => {
        state.isSpacePressed = false
      })
      stopRecording()
      console.log('麦克风已关闭，开始识别...')
    }
  }, [stopRecording, update])

  useEffect(() => {
    window.addEventListener('keydown', handleKeyDown)
    window.addEventListener('keyup', handleKeyUp)

    return () => {
      window.removeEventListener('keydown', handleKeyDown)
      window.removeEventListener('keyup', handleKeyUp)
    }
  }, [handleKeyDown, handleKeyUp])

  return {
    isListening,
    isRecording,
    isTranscribing,
    text,
    isAgentProcessing
  }
}



